import "./basepage.css"
import { Outlet, useLocation } from 'react-router-dom';
import Box from '@mui/joy/Box';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import HeaderOffset from "../components/HeaderOffset";
import { SidebarProvider } from "../hooks/useSidebar";
import { basePageMainSx } from '../theme/shellStyles';

const BasePage = () => {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', height: '100%', minHeight: 0 }}>
      <SidebarProvider>
        <Header />
        <Sidebar />
        <Box component="main" sx={basePageMainSx}>
          {/* Layout contract: child pages must use height: '100%' instead of viewport math */}
          <HeaderOffset sx={{ display: { xs: 'block', md: 'block', lg: 'none' } }} />
          <TransitionGroup style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
            <CSSTransition
              key={location.pathname} // Ensure a unique key for each route
              timeout={300} // Duration of the animation
              classNames="fade"
              unmountOnExit // CSS class prefix
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: '100%' }}>
                <Outlet />
              </Box>
            </CSSTransition>
          </TransitionGroup>
        </Box>
      </SidebarProvider>
    </Box>
  );
}

export default BasePage
